import React from "react";
import { Show, SimpleShowLayout, TextField } from "react-admin";

export const AutoInsuranceCompanyShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
    </SimpleShowLayout>
  </Show>
);
